import styled from "styled-components";

export const AboutTravelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 19px 15px;
  width: 100%;
  height: auto;
  gap: 9px;
  background: #c4c4c4;
`;

export const UpperBlock = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 29px;
`;
